export enum UserLocalSettingsKey {
  locale = 'locale',
  view = 'view',
  theme = 'theme',
}

export type UserView = 'grid' | 'row';
export type UserTheme = 'light-theme' | 'dark-theme';

export type UserLocalSettings = {
  [UserLocalSettingsKey.view]: UserView;
  [UserLocalSettingsKey.theme]?: UserTheme;
};

const DEFAULT_USER_SETTINGS: UserLocalSettings = {
  view: 'row',
};

export const getInitialUserSettings = (): UserLocalSettings =>
  (Object.keys(DEFAULT_USER_SETTINGS) as UserLocalSettingsKey[]).reduce(
    (result, key: UserLocalSettingsKey) => {
      const value = localStorage.getItem(key);

      if (value) {
        return {
          ...result,
          [key]: value,
        };
      }

      return result;
    },
    DEFAULT_USER_SETTINGS,
  );
